// src/components/kreator/KreatorBanner.jsx
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Wand2, ArrowRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';

export default function KreatorBanner({ progress }) {
  const navigate = useNavigate();

  if (!progress || progress.isAllComplete) {
    return null;
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Card className="bg-gradient-to-r from-indigo-600 to-violet-600 text-white border-0 overflow-hidden relative">
        {/* Decorative background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute -right-8 -top-8 w-32 h-32 bg-white rounded-full" />
          <div className="absolute -right-4 -bottom-4 w-24 h-24 bg-white rounded-full" />
        </div>

        <CardContent className="p-6 relative">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* Left side - Icon and text */}
            <div className="flex items-center gap-4">
              <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
                <Wand2 className="w-8 h-8" />
              </div>
              <div>
                <h3 className="text-xl font-bold">Kreator placówki</h3>
                <p className="text-indigo-100">
                  Ukończono {progress.completedCount} z {progress.totalCount} kroków
                </p>
              </div>
            </div>

            {/* Right side - Progress and button */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
              <div className="flex items-center gap-3">
                <Progress
                  value={progress.progressPercent}
                  className="w-32 h-2 bg-white/20"
                />
                <span className="text-lg font-bold">{progress.progressPercent}%</span>
              </div>
              <Button
                variant="secondary"
                onClick={() => navigate('/Kreator')}
                className="bg-white text-indigo-700 hover:bg-indigo-50 font-semibold"
              >
                Kontynuuj
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
}
